import * as React from "react"
import AddHelpContactFormView from "./AddHelpContactFormView";
import HelpRequest from "../../../../model/help/HelpRequest";
import Toast from "../../../helper/Toast";
import {OnFailure, OnSuccess} from "../../../../store/action/actionHelpers";
import {Dispatch} from "redux";
import {sendHelpRequest} from "../../../../store/action/help/help";
import {connect} from "react-redux";

interface DispatchProps {
	/**
	 * Send help request
	 * @param {HelpRequest} data
	 * @param {OnSuccess} onSuccess
	 * @param {OnFailure} onFailure
	 */
	sendHelpRequest: (data: HelpRequest, onSuccess: OnSuccess, onFailure: OnFailure) => void;
	/**
	 * On help contact form cancel handler.
	 */
	onCancel: () => void
}

interface State {
	/**
	 * Indicating if request to server is in progress.
	 */
	isLoading: boolean
}

type Props = DispatchProps;

/**
 * Add new help contact form.
 */
class AddHelpContactForm extends React.PureComponent<Props, State> {

	constructor(props: Props) {
		super(props);
		this.state = {
			isLoading: false
		};
		this.onSubmit = this.onSubmit.bind(this);
	}

	render() {
		return (
			<AddHelpContactFormView onCancel={this.props.onCancel}
									isLoading={this.state.isLoading}
									label={"Create help"}
									onSubmit={this.onSubmit}/>
		);
	}

	onSubmit(data: HelpRequest) {
		this.setState({isLoading: true});
		this.props.sendHelpRequest(data, () => {
			this.props.onCancel();
			Toast.success("Message sent successfully", "Help request");
		}, () => {Toast.error("Sorry, something went wrong. Try again later.", "Sent help request error")})
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		sendHelpRequest: (data: HelpRequest, onSuccess: OnSuccess, onFailure: OnFailure) => dispatch(
			sendHelpRequest(data, onSuccess, onFailure))
	}
}

export default connect(null, mapDispatchToProps)<DispatchProps>(AddHelpContactForm)